import { fromJS } from 'immutable';
import {
  ADD_OFFICER_SUCCESS,
  UPDATE_OFFICER_SUCCESS,
  DELETE_OFFICER_SUCCESS,
  ON_SHAREHOLDER_VALUE_CHANGE
} from './actions';
import {
  OFFICER_DETAILS,
  TYPE_UK_ADDRESS,
  PRIMARY_APPLICANT,
  OFIICER_KEY
} from '../../utils/constants';
import { postCodeFormat } from '../../components/Address/addressUtils/addressUtils';
import {
  mapOfficerDetails,
  mapPrimaryApplicant,
  getOfficersFromCase
} from './payloadUtils/mapOfiicerDetails';
import { FETCH_CUSTOMERBYID_SUCCESS } from '../customers';
import { FETCH_CASE_SUCCESS } from '../cases';
export const OFFER_API_DATA = 'offerProductData';
export const initialState = fromJS({
  loading: false
});

const PRIMARY_ADD_OFFICER_SUCCESS = 'PRIMARY_ADD_OFFICER_SUCCESS';
const PRIMARY_UPDATE_OFFICER_SUCCESS = 'PRIMARY_UPDATE_OFFICER_SUCCESS';

const officerReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_OFFICER_SUCCESS:
      return state.set(
        OFFICER_DETAILS,
        getOfficer(state, action.meta.data, action.payload.officer_id)
      );
    case PRIMARY_ADD_OFFICER_SUCCESS:
      return state.set(
        PRIMARY_APPLICANT,
        mapPrimaryApplicant(action.meta.data, action.payload.officer_id)
      );
    case UPDATE_OFFICER_SUCCESS:
      return state.set(OFFICER_DETAILS, setOfficerByIndex(state, action.meta.data));
    case DELETE_OFFICER_SUCCESS:
      return state.set(OFFICER_DETAILS, removeOfficerByIndex(state, action.meta.index));
    case ON_SHAREHOLDER_VALUE_CHANGE:
      return saveOfficersValue(action.data, state);
    default:
      return processRemainingActions(action, state);
  }
};

const processRemainingActions = (action, state) => {
  switch (action.type) {
    case `${OFIICER_KEY}${FETCH_CUSTOMERBYID_SUCCESS}`:
      return state.set(PRIMARY_APPLICANT, mapOfficerDetails(action.payload, state, true));
    case PRIMARY_UPDATE_OFFICER_SUCCESS:
      return state.set(PRIMARY_APPLICANT, action.meta.data.officer);
    case FETCH_CASE_SUCCESS:
      return state
        .set(PRIMARY_APPLICANT, mapOfficerDetails(action.payload, state))
        .set(OFFICER_DETAILS, getOfficersFromCase(action.payload, state));
    default:
      return state;
  }
};

const getOfficer = (state, data, id) => {
  const officers = state.get(OFFICER_DETAILS) || [];
  data.officer_id = data.officer_id ? data.officer_id : id;
  officers.push(data);
  return officers;
};

const setOfficerByIndex = (state, data) => {
  const officers = state.get(OFFICER_DETAILS);
  officers[data.index] = data.officer;
  return officers;
};

const removeOfficerByIndex = (state, index) => {
  const officers = state.get(OFFICER_DETAILS);
  officers.splice(index, 1);
  return officers;
};

const saveOfficersValue = (data, state) => {
  const { name, value, index } = data;
  const officers = state.get(OFFICER_DETAILS);
  const currentOfficers = officers ? officers[index] : '';
  if (currentOfficers && name) {
    let formValue = value;
    if (name.indexOf('postcode') > -1) {
      formValue = postCodeFormat(formValue);
    }
    if (isAddress(name)) {
      return checkForSplittedAddress(
        name.split('.'),
        currentOfficers,
        formValue,
        officers,
        index,
        state
      );
    }

    currentOfficers[name] = formValue;
    officers[index] = currentOfficers;
    return state.set(OFFICER_DETAILS, officers);
  }
  return state;
};

const checkForSplittedAddress = (splited_name, currentOfficers, value, officers, index, state) => {
  if (splited_name) {
    let data;
    if (splited_name.length === 2) {
      data = currentOfficers[splited_name[0]] || {};
      data[splited_name[1]] = value;
    } else {
      data = currentOfficers[splited_name[0]] || {};
      data[splited_name[2]]
        ? (data[splited_name[1]][splited_name[2]] = value)
        : (data[splited_name[1]] = Object.assign({}, data[splited_name[1]], {
            [splited_name[2]]: value
          }));
    }
    currentOfficers[splited_name[0]] = data;
    officers[index] = currentOfficers;
    return state.set(OFFICER_DETAILS, officers);
  }
  return state;
};

const isAddress = name => name.indexOf(`${TYPE_UK_ADDRESS}`) > -1;

export default officerReducer;
